import React from 'react'
import { useTranslation } from 'react-i18next'

import { Checkbox, CheckboxChangeEvent } from 'primereact/checkbox'
import { InputTextarea, InputTextareaProps } from 'primereact/inputtextarea'
import { TooltipOptions } from 'primereact/tooltip/tooltipoptions'
import { classNames } from 'primereact/utils'

export interface InputTextareaToggleableProps extends InputTextareaProps {
  checked: boolean
  onCheckedChange: (event: CheckboxChangeEvent) => void
  checkboxTooltip?: string
  checkboxTooltipOptions?: TooltipOptions
}

export const InputTextareaToggleable: React.FC<
  InputTextareaToggleableProps
> = ({
  checked = false,
  onCheckedChange,
  checkboxTooltip,
  checkboxTooltipOptions,
  disabled,
  ...props
}) => {
  const { t } = useTranslation()

  if (disabled)
    return <InputTextarea className="w-full" disabled={disabled} {...props} />

  return (
    <div className="p-inputgroup">
      <span
        className={classNames('p-inputgroup-addon', { 'p-disabled': !checked })}
      >
        <Checkbox
          checked={checked}
          onChange={onCheckedChange}
          tooltip={
            checkboxTooltip ||
            t('components.inputs.inputTextToggleable.checkBoxTooltip')
          }
          tooltipOptions={{
            ...checkboxTooltipOptions,
            position: checkboxTooltipOptions?.position || 'left',
          }}
        />
      </span>
      <InputTextarea disabled={disabled || !checked} {...props} />
    </div>
  )
}
